import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

@Injectable({
    providedIn: 'root'
})
export class PayrollPeriodService {

    constructor(private api: ApiService) { }

    list(params: any = {}): Observable<any> {
        const cleanParams: any = {};
        Object.keys(params || {}).forEach((key) => {
            const value = params[key];
            if (value !== null && value !== undefined && value !== '') {
                cleanParams[key] = String(value);
            }
        });
        const queryString = new URLSearchParams(cleanParams).toString();
        return this.api.get(`hr/payroll-periods${queryString ? '?' + queryString : ''}`);
    }

    current(): Observable<any> {
        return this.api.get('hr/payroll-periods/current');
    }

    show(id: number | string): Observable<any> {
        return this.api.get(`hr/payroll-periods/${id}`);
    }

    closedStatus(): Observable<any> {
        return this.api.get('hr/payroll-periods/closed-status');
    }

    create(payload: any = {}): Observable<any> {
        return this.api.post('hr/payroll-periods', payload);
    }

    verifyPassword(id: number | string, password: string): Observable<any> {
        return this.api.post(`hr/payroll-periods/${id}/verify-password`, { password });
    }

    close(id: number | string): Observable<any> {
        return this.api.post(`hr/payroll-periods/${id}/close`, {});
    }

    reopen(id: number | string): Observable<any> {
        return this.api.post(`hr/payroll-periods/${id}/reopen`, {});
    }
}
